import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LOCALES } from "./translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => localStorage.getItem("locale") || "tr");

  useEffect(() => {
    const dir = LOCALES[locale]?.dir || "ltr";
    document.documentElement.setAttribute("lang", locale);
    document.documentElement.setAttribute("dir", dir);
    localStorage.setItem("locale", locale);
  }, [locale]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[locale];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) break;
      }
      if (node === undefined) {
        let fb = translations.en;
        for (const p of parts) fb = fb?.[p];
        return fb ?? path;
      }
      return node;
    },
    [locale]
  );

  const dir = LOCALES[locale]?.dir || "ltr";
  return (
    <I18nContext.Provider value={{ locale, setLocale, t, dir, locales: LOCALES }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
